import {HStack, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface BpmEstimateRowProps extends TestIdProps {
  label: string;
  value: string;
  isEmphasized?: boolean;
}

export function BpmEstimateRow(props: BpmEstimateRowProps) {
  return (
    <HStack justify="space-between" align="baseline" spacing={2}>
      <Text size="xSmall" color={props.isEmphasized ? 'primary' : 'secondary'}>
        {props.label}
      </Text>
      <Text
        size="small"
        noWrap
        alternative={props.isEmphasized}
        data-testid={suffixTestId('value', props)}
      >
        {props.value}
      </Text>
    </HStack>
  );
}
